import React from "react";

/**
 * Converted SVG to React component using https://svgr.now.sh/
 * See https://github.com/smooth-code/svgr for details.
 */
const VideoPlaceholder = props => (
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1280 720"
    {...props}
  >
    <title>MLB placeholder</title>
    <defs>
      <path id="a" d="M0 0h1280v720H0z" />
    </defs>
    <clipPath id="b">
      <use xlinkHref="#a" overflow="visible" />
    </clipPath>
    <g clipPath="url(#b)">
      <defs>
        <path id="c" d="M0 0h1280v720H0z" />
      </defs>
      <clipPath id="d">
        <use xlinkHref="#c" overflow="visible" />
      </clipPath>
      <path clipPath="url(#d)" fill="#ececec" d="M-5-5h1290v730H-5z" />
    </g>
    <defs>
      <path id="e" d="M0 0h1280v720H0z" />
    </defs>
    <clipPath id="f">
      <use xlinkHref="#e" overflow="visible" />
    </clipPath>
    <g opacity={0.08} clipPath="url(#f)">
      <defs>
        <path id="g" d="M551 315h178v91H551z" />
      </defs>
      <clipPath id="h">
        <use xlinkHref="#g" overflow="visible" />
      </clipPath>
      <g clipPath="url(#h)">
        <defs>
          <path
            id="i"
            d="M725.684 317.973A10.18 10.18 0 0 0 718.48 315l-156.328.152a10.103 10.103 0 0 0-7.183 2.98c-1.92 1.92-2.987 4.474-2.97 7.196l.06 69.905a10.122 10.122 0 0 0 2.99 7.187 10.1 10.1 0 0 0 7.182 2.977l156.34-.152c5.608 0 10.173-4.57 10.173-10.177l-.085-69.91c0-2.712-1.065-5.257-2.976-7.185h.001z"
          />
        </defs>
        <clipPath id="j">
          <use xlinkHref="#i" overflow="visible" />
        </clipPath>
        <g clipPath="url(#j)">
          <defs>
            <path id="k" d="M551 315h178v91H551z" />
          </defs>
          <clipPath id="l">
            <use xlinkHref="#k" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#l)"
            fill="#fff"
            d="M546.999 310h186.745v100.397H546.999z"
          />
        </g>
      </g>
      <g clipPath="url(#h)">
        <defs>
          <path
            id="m"
            d="M725.684 317.973A10.18 10.18 0 0 0 718.48 315l-43.692.05 25.19 41.93 2.274.286 1.353 1.907.016 1.814 1.617.304 1.454 1.997v1.725l1.617.292s1.63 1.713 1.63 1.805l.027 3.922s3.534 3.26 6.688 4.5c2.224.86 2.495 4.396 3.772 6.316 1.708 2.67 4.008 3.826 3.535 5.365-1.134 4.11-5.354 11.014-9.277 11.398 0 0-9.784.022-15.517.03v6.625l19.406-.02c5.607 0 10.172-4.57 10.172-10.178l-.085-69.91c0-2.71-1.065-5.256-2.976-7.184v-.001z"
          />
        </defs>
        <clipPath id="n">
          <use xlinkHref="#m" overflow="visible" />
        </clipPath>
        <g clipPath="url(#n)">
          <defs>
            <path id="o" d="M551 315h178v91H551z" />
          </defs>
          <clipPath id="p">
            <use xlinkHref="#o" overflow="visible" />
          </clipPath>
          <path clipPath="url(#p)" d="M669.788 310h63.957v100.266h-63.957z" />
        </g>
      </g>
      <g clipPath="url(#h)">
        <defs>
          <path
            id="q"
            d="M573.081 390.988c-3.86.014-6.984-3.107-6.996-6.967a6.993 6.993 0 0 1 6.976-6.992c3.848-.01 6.976 3.116 6.985 6.976a6.968 6.968 0 0 1-6.964 6.985l-.001-.002zm86.816-75.92l-97.745.084a10.103 10.103 0 0 0-7.183 2.98c-1.92 1.92-2.987 4.474-2.97 7.196l.06 69.905a10.122 10.122 0 0 0 2.99 7.187 10.1 10.1 0 0 0 7.182 2.977l63.495-.063c-1.593-2.65-3.387-5.67-3.948-6.588l-7.557.013c-.034-18.773 6.363-29.216 13.923-31.237 1.062-.195.576-5.37-.77-6.9 0 0-3.63.1-4.396-.09-.956-.29-.3-1.237-.3-1.237l3.54-7.674-.483-2.11-13.128.026c-.187 0 10.81-7.58 10.81-7.58.55-19.92 20.946-21.478 33.325-13.268 7.272 4.884 7.873 14.46 7.298 21.153-.094.384-1.912.1-1.912.1s-1.24 7.28 2.03 7.28l14.35-.024c5.835-.204 11.5 3.707 11.5 3.707l1.42-4.968-31.533-40.872.002.003z"
          />
        </defs>
        <clipPath id="r">
          <use xlinkHref="#q" overflow="visible" />
        </clipPath>
        <g clipPath="url(#r)">
          <defs>
            <path id="s" d="M551 315h178v91H551z" />
          </defs>
          <clipPath id="t">
            <use xlinkHref="#s" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#t)"
            d="M546.999 310.065h149.429v100.332H546.999z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default VideoPlaceholder;



// WEBPACK FOOTER //
// ./src/components/VideoPlaceholder.js